import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import ApiUsers from "./ApiUsers";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<ApiUsers />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
